import { collection, limit, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function subscribeInvoicesByClient(clientId, onData, onError) {
  const sources = [];
  sources.push({ key: 'root', ref: collection(db, 'invoices') });
  if (appId) {
    sources.push({ key: 'artifacts', ref: collection(db, ...FS.invoices(appId)) });
  }

  const maps = sources.map(() => new Map());
  const ready = sources.map(() => false);
  const unsubscribers = [];

  const recompute = () => {
    const merged = new Map();
    for (let i = sources.length - 1; i >= 0; i -= 1) {
      maps[i].forEach((v, k) => merged.set(k, v));
    }
    onData(Array.from(merged.values()));
  };

  sources.forEach((s, idx) => {
    const qq = query(s.ref, where('clientId', '==', clientId), limit(500));
    const unsub = onSnapshot(
      qq,
      (snap) => {
        const next = new Map();
        snap.docs.forEach((d) => next.set(d.id, { id: d.id, ...(d.data() || {}) }));
        maps[idx] = next;
        ready[idx] = true;
        recompute();
      },
      (e) => {
        ready[idx] = true;
        onError?.(e);
        recompute();
      }
    );
    unsubscribers.push(unsub);
  });

  return () => {
    unsubscribers.forEach((u) => {
      try { u && u(); } catch { void 0; }
    });
  };
}
